export default {
  SET_ZONES ( state, payload){
    state.zones = payload
  }
}
